module.exports = __webpack_public_path__ + "img/about_title3.3fefee0c.png";